import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lmbr-ameno/lmbr-ameno/src/presenters/components/common/WhatsAppButton/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lmbr-ameno/lmbr-ameno/src/presenters/components/modular-content/ModularContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useModularContentStore"] */ "/home/runner/work/lmbr-ameno/lmbr-ameno/src/presenters/store/modular-content/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lmbr-ameno/lmbr-ameno/src/presenters/store/modular-content/provider.tsx");
